/**
 * Document URLs Configuration
 * 
 * Central configuration for all publicly accessible document URLs
 * Update these URLs when documents are uploaded to Firebase Storage
 */

export const DOCUMENT_URLS = {
  /**
   * Rental Terms and Conditions PDF
   * Location: Hosted on Firebase Hosting at /tnc
   * Source file: public/tnc.pdf
   * 
   * Updated: May 19, 2026
   * 
   * To update:
   * 1. Replace public/tnc.pdf with new PDF
   * 2. Build and deploy the application
   */
  RENTAL_TERMS: 'https://beemascaffolding.sg/tnc',
};

/**
 * Get rental terms URL
 * @returns {string} Rental terms PDF URL
 */
export const getRentalTermsURL = () => {
  return DOCUMENT_URLS.RENTAL_TERMS;
};

/**
 * Validate that document URLs are configured
 * @returns {boolean} True if all required URLs are set
 */
export const areDocumentURLsValid = () => {
  return DOCUMENT_URLS.RENTAL_TERMS && 
         DOCUMENT_URLS.RENTAL_TERMS.startsWith('http');
};

export default DOCUMENT_URLS;
